export default __webpack_public_path__ + "static/media/news2.7609b431.png";